import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { MdAdd, MdArticle, MdCached, MdLogout } from "react-icons/md";
import LogoViewer from "../../components/LogoViewer";
import { trackPageView } from "~/utils/analytics";
import "./styles.scss";
import { verifyFeaturePermission } from "~/api";
import OperationTypePickerModal from "./components/OperationTypePickerModal";

const OPERATION_TYPE_PICKER_MODAL = "OPERATION_TYPE_PICKER_MODAL";

const Home = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const [isLoadingClickHandler, setIsLoadingClickHandler] = useState(false);
  const [openModal, setOpenModal] = useState(null);

  const handleCreateOperationClick = useCallback(
    type => {
      history.push(`/new-operation?startFrom=${type}`);
    },
    [history]
  );

  const operationClickHandler = useCallback(() => {
    setIsLoadingClickHandler(true);

    verifyFeaturePermission(["proposta.inicio_gleba"]).then(res => {
      const result = res.data;

      setIsLoadingClickHandler(false);

      if (!result.has_access) {
        handleCreateOperationClick("car");
        return;
      }

      setOpenModal(OPERATION_TYPE_PICKER_MODAL);
    });
  }, [handleCreateOperationClick]);

  const handleActionClick = (action) => {
    console.log(action);
    switch (action) {
      case 'criar-operacao':
        operationClickHandler();
        break;
      case 'listar-operacoes':
        history.push('operations');
        break;
      case 'sair':
        trackPageView("/logout");
        localStorage.removeItem("access_token");
        localStorage.removeItem("@BusCAR/dashboard-access");
        localStorage.removeItem("@BusCAR:ambient");
        history.push("/login");

        break;
      default: {
        return;
      }
    }
  }

  return (
    <>
      <div className="operation-header">
        <h1>{formatMessage({ id: "pagina-inicial" })}</h1>

        <LogoViewer>
        </LogoViewer>
      </div>

      <div className="content-box operation">
        <h3>
          {formatMessage({ id: "central-acoes" })}&nbsp;
          {isLoadingClickHandler && (
            <MdCached className="loader-only-rotation" size={16} />
          )}
        </h3>

        <div className="action-wrapper">
          <ActionButton
            label={formatMessage({ id: "criar-operacao" })}
            icon={MdAdd}
            onClick={() => handleActionClick('criar-operacao')}
          />

          <ActionButton
            label={formatMessage({ id: "listar-operacoes" })}
            icon={MdArticle}
            onClick={() => handleActionClick('listar-operacoes')}
          />

          <ActionButton
            label={formatMessage({ id: "sair" })}
            icon={MdLogout}
            onClick={() => handleActionClick('sair')}
          />
        </div>
      </div>

      {openModal === OPERATION_TYPE_PICKER_MODAL && (
        <OperationTypePickerModal
          onClose={() => setOpenModal(null)}
          onSelectStart={type => handleCreateOperationClick(type)}
        />
      )}
    </>
  );
};

const ActionButton = ({ label, icon: Icon, onClick }) => {
  return (
    <button onClick={onClick} className="action-button">
      <Icon />&nbsp;
      {label}
    </button>
  );
}

export default Home;
